import firebase from "firebase";
var firebaseConfig = {
  apiKey: "AIzaSyD2juXJcj0mwz4A9l6sG2ilHUFq89zMoWw",
  authDomain: "thathinh-2021.firebaseapp.com",
  databaseURL:
    "https://thathinh-2021-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "thathinh-2021",
  storageBucket: "thathinh-2021.appspot.com",
  messagingSenderId: "595351192793",
  appId: "1:595351192793:web:28de6fdeed1cbe93d62ac8",
  measurementId: "G-BS8BFVETHM",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
export const dbListThinh = firebase.database().ref("listThinh");
export const dbType = firebase.database().ref('typeCategoryName');